const modules = (state = [], action) => {
  switch (action.type) {
    case 'modules.data':
      return Object.assign([], state, [...action.Module]);
    case 'modules.reset':
      return Object.assign([], state, []);
    default:
      return state;
  }
};

export default modules;
